export const conditionDisable = (disabled) => {
    if (!disabled) return ``;
    else
        return `
            background: var(--form-control-disabled-background-color)!important;
            cursor: not-allowed!important;
            border-color:  var(--form-control-disabled-border-color)!important;
            opacity: 1!important;
            * {
                    color: var(--form-control-disabled-text-color)!important;
            }
            
            &::before {
                background-image: linear-gradient(to left, var(--form-control-disabled-background-color), var(--form-control-disabled-background-color), var(--form-control-disabled-background-color), var(--form-control-disabled-mask-background-color))!important;
            }
            *{
                cursor: not-allowed!important;
            }
        `;
};
